import { useEffect } from "react";
import { Link } from "react-router-dom";

import useAnchorNav from "../../hooks/useAnchorNav";
import useI18n from "../../i18n/useI18n";
import LanguageToggle from "./LanguageToggle";
import { pageLinks, anchorLinks, aiCta } from "../../data/navConfig";

const MobileDrawer = ({ isOpen, onClose }) => {
  const navigateToHash = useAnchorNav();
  const { t } = useI18n();

  // Lock body scroll while open + close on Escape.
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    document.body.style.overflow = "hidden";
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen, onClose]);

  const handleAnchor = (event, id) => {
    event.preventDefault();
    navigateToHash(id, { onDone: onClose });
  };

  return (
    <div
      id="mobile-drawer"
      className={`mobile-drawer${isOpen ? " is-open" : ""}`}
      aria-hidden={!isOpen}
    >
      <div className="mobile-drawer__top">
        <button
          type="button"
          className="mobile-drawer__close"
          aria-label={t("lang.label")}
          onClick={onClose}
        >
          ×
        </button>
        <LanguageToggle />
      </div>

      {pageLinks.map((item) => (
        <Link key={item.id} to={item.to} className="mobile-drawer__link" onClick={onClose}>
          {t(item.labelKey)}
        </Link>
      ))}
      {anchorLinks.map((item) => (
        <a
          key={item.id}
          href={item.hash}
          className="mobile-drawer__link"
          onClick={(event) => handleAnchor(event, item.id)}
        >
          {t(item.labelKey)}
        </a>
      ))}

      <a
        href={aiCta.hash}
        className="mobile-drawer__cta"
        onClick={(event) => handleAnchor(event, aiCta.id)}
      >
        {t(aiCta.labelKey)}
      </a>
    </div>
  );
};

export default MobileDrawer;
